import React, { Component } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme, themeClass } from '../../../constants/styling/themes';
import { noop } from 'lodash';
import Checkbox from '../../forms/Checkbox';

const FORCE_OPEN_CLASS = 'ckp-js-select-force-open';

class CategoryVisibilitySelector extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    _onChange = (ev) => {
        const value = ev.target.value.filter((v) => v !== undefined && v !== null);
        this.props.onChange(value);
    };

    _onOpen = () => {
        this.setState({ open: true });
    };

    _onClose = (ev) => {
        const targetName = ev.target.getAttribute('name');
        if (targetName !== FORCE_OPEN_CLASS) {
            this.setState({ open: false });
        }
    };

    _renderValue = (value) => {
        const { categories } = this.props;
        const selectedLabels = categories.filter((cat) => value.includes(cat.id)).map((cat) => cat.label);

        return selectedLabels.length > 0 ? selectedLabels.join(', ') : '';
    };

    _selectAll = () => {
        const { categories, selectedCategories } = this.props;
        const selectableCategories = categories.filter((cat) => !cat.visibleByDefault);
        const selectableCategoryIds = selectableCategories.map((cat) => cat.id);

        if (selectableCategoryIds.every((id) => selectedCategories.includes(id))) {
            // Unselect all
            const updatedCategories = selectedCategories.filter((id) => !selectableCategoryIds.includes(id));
            this.props.onChange(updatedCategories);
        } else {
            // Select all
            const allIds = [...new Set([...selectedCategories, ...selectableCategoryIds])];
            this.props.onChange(allIds);
        }
    };

    render() {
        const {
            categories = [],
            selectedCategories = [],
            showSelectAll = true,
            label = 'Visible Categories'
        } = this.props;

        if (categories.length === 0) {
            return <p className="u-italic u-margin-bottom-2">No categories configured for this event yet.</p>;
        }

        const selectableCategories = categories.filter((cat) => !cat.visibleByDefault);
        const selectableCategoryIds = selectableCategories.map((cat) => cat.id);
        const allSelected =
            selectableCategoryIds.length > 0 && selectableCategoryIds.every((id) => selectedCategories.includes(id));

        return (
            <div className="ckp-forms-element">
                <MuiThemeProvider theme={theme()}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="category-visibility-select">{label}</InputLabel>
                        <Select
                            open={this.state.open}
                            onOpen={this._onOpen}
                            onClose={this._onClose}
                            displayEmpty={true}
                            value={selectedCategories}
                            onChange={this._onChange}
                            multiple={true}
                            inputProps={{
                                name: 'categoryIds',
                                id: 'category-visibility-select'
                            }}
                            renderValue={this._renderValue}
                            input={<Input fullWidth name="categoryIds" value={selectedCategories} />}
                            MenuProps={{ classes: { paper: 'ckp-selects-menu' } }}
                        >
                            {showSelectAll && selectableCategories.length > 0 && (
                                <div key="ckp-selects-select-all-key" className="ckp-selects-select-all">
                                    <Checkbox
                                        name="select-all-categories"
                                        checked={allSelected}
                                        halfChecked={selectedCategories.length > 0 && !allSelected}
                                        onChange={this._selectAll}
                                        label={allSelected ? 'Unselect all' : 'Select all'}
                                    />
                                </div>
                            )}
                            {categories.map((category) => {
                                const isChecked = category.visibleByDefault || selectedCategories.includes(category.id);
                                const isDisabled = category.visibleByDefault;
                                return (
                                    <MenuItem
                                        className="ckp-selects-menu-item"
                                        key={category.id}
                                        value={category.id}
                                        disabled={isDisabled}
                                    >
                                        <Checkbox
                                            name={`category-${category.id}`}
                                            onChange={noop}
                                            checked={isChecked}
                                            disabled={isDisabled}
                                        />
                                        {category.label}
                                        {category.visibleByDefault && (
                                            <span className="u-italic u-margin-left-1" style={{ fontSize: '0.85em' }}>
                                                (visible by default)
                                            </span>
                                        )}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </MuiThemeProvider>
            </div>
        );
    }
}

export default CategoryVisibilitySelector;
